import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_measures_in_place_relate_1'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_measures_in_place_relate_1',
  name: 'Does the facility have any of the following measures in place related to Personal Protective Equipment (PPE)?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'PPE_EQUIPMENT_AND_CLOTHING_PROVIDED_IS_IN_GOOD_CONDITION_AND_RE',
      text: 'PPE equipment and clothing provided is in good condition and replaced as needed to ensure effectiveness and protect workers from identified hazards',
      externalIds: [
        {
          id: 'hs-31--1-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PPE_IS_THE_CORRECT_SIZE_FOR_WORKERS',
      text: 'PPE is the correct size for workers',
      externalIds: [
        {
          id: 'hs-31--1-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PPE_EQUIPMENT_SUCH_AS_HEARING_PROTECTION_IS_PROVIDED_WHERE_NOIS',
      text: 'PPE equipment (such as hearing protection) is provided where noise levels approach or exceed the equivalent dose of 85 decibels (dB) for 8 hours',
      externalIds: [
        {
          id: 'hs-31--1-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PPE_EQUIPMENT_AND_CLOTHING_PROVIDED_IS_CONSISTENTLY_AND_EFFECTI',
      text: 'PPE equipment and clothing provided is consistently and effectively used by workers',
      externalIds: [
        {
          id: 'hs-31--1-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WARNINGS_EITHER_THROUGH_VERBAL_OR_WRITTEN_COMMUNICATION_ARE_USE',
      text: 'Warnings (either through verbal or written communication) are used to ensure that workers use PPE equipment and clothing',
      externalIds: [
        {
          id: 'hs-31--1-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PENALTIES_MONETARY_OR_OTHERWISE_ARE_USED_TO_ENSURE_THAT_WORKERS',
      text: 'Penalties (monetary or otherwise) are used to ensure that workers use PPE equipment and clothing',
      externalIds: [
        {
          id: 'hs-31--1-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe the penalties (monetary or otherwise) used by the facility to ensure that workers use PPE equipment and clothing:',
        externalIds: [
          {
            id: 'hs-31--1-8f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'THE_FACILITY_ENSURES_THE_APPROPRIATE_AND_SAFE_STORAGE_OF_PPE_EQ',
      text: 'The facility ensures the appropriate and safe storage of PPE equipment and clothing on-site',
      externalIds: [
        {
          id: 'hs-31--1-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-31--1-10x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If yes, please describe what type of laser or radiation equipment is used in the facility:',
        externalIds: [
          {
            id: 'hs-32--1-1f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'PPE_EQUIPMENT_AND_CLOTHING_PROVIDED_IS_IN_GOOD_CONDITION_AND_RE',
                'PPE_IS_THE_CORRECT_SIZE_FOR_WORKERS',
                'PPE_EQUIPMENT_SUCH_AS_HEARING_PROTECTION_IS_PROVIDED_WHERE_NOIS',
                'PPE_EQUIPMENT_AND_CLOTHING_PROVIDED_IS_CONSISTENTLY_AND_EFFECTI',
                'WARNINGS_EITHER_THROUGH_VERBAL_OR_WRITTEN_COMMUNICATION_ARE_USE',
                'PENALTIES_MONETARY_OR_OTHERWISE_ARE_USED_TO_ENSURE_THAT_WORKERS',
                'THE_FACILITY_ENSURES_THE_APPROPRIATE_AND_SAFE_STORAGE_OF_PPE_EQ',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-wor-1',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 15740,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
